import React, { Component } from "react";

import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import { withRouter } from "react-router-dom";

import { Dialog, Button, Intent } from "@blueprintjs/core";
import { Grid, Row, Col } from "react-flexbox-grid";

import {
  setPropDataObject,
  salvar,
  close,
} from "../../actions/acesso/CadAcesso";

class CadAcesso extends Component {
  render() {
    let { dataObject, isOpen, isFetching, error, required } = this.props;

    return (
      <Dialog
        isOpen={isOpen}
        onClose={() => {
          this.close();
        }}
        title="Configurações de acesso"
        canEscapeKeyClose={false}
        canOutsideClickClose={false}
      >
        <div className="pt-dialog-body">
          <div className="pt-card .modifier">
            <Grid fluid style={{ paddingRight: 0, paddingLeft: 0 }}>
              <Row>
                <Col xs>
                  <div className="pt-form-group">
                    <label className="pt-label">
                      {required.name ? "*" : ""}Nome do acesso
                    </label>
                    <div className="pt-form-content">
                      <div
                        className={`pt-input-group ${error.name ? "pt-intent-danger" : ""}`}
                      >
                        <input
                          type="text"
                          className="pt-input pt-round"
                          placeholder=""
                          value={dataObject.name}
                          onChange={({ target }) => {
                            this.onChange({ name: target.value });
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col xs>
                  <div className="pt-form-group">
                    <label className="pt-label">
                      {required.group ? "*" : ""}Conta da empresa
                    </label>
                    <div className="pt-form-content">
                      <div
                        className={`pt-input-group ${error.group ? "pt-intent-danger" : ""}`}
                      >
                        <input
                          type="text"
                          className="pt-input pt-round"
                          placeholder=""
                          value={dataObject.group}
                          onChange={({ target }) => {
                            this.onChange({ group: target.value });
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </Col>
                <Col xs>
                  <div className="pt-form-group">
                    <label className="pt-label">
                      {required.client_key ? "*" : ""}Senha de acesso
                    </label>
                    <div className="pt-form-content">
                      <div
                        className={`pt-input-group ${error.client_key ? "pt-intent-danger" : ""}`}
                      >
                        <input
                          type="text"
                          className="pt-input pt-round"
                          placeholder=""
                          value={dataObject.client_key}
                          onChange={({ target }) => {
                            this.onChange({ client_key: target.value });
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col xs>
                  <div className="pt-form-group">
                    <label className="pt-label">
                      {required.default_licenses ? "*" : ""}Licenças contratadas
                    </label>
                    <div className="pt-form-content">
                      <div
                        className={`pt-input-group ${error.default_licenses ? "pt-intent-danger" : ""}`}
                      >
                        <input
                          type="text"
                          className="pt-input pt-round"
                          placeholder=""
                          value={dataObject.default_licenses}
                          onChange={({ target }) => {
                            this.onChange({ default_licenses: target.value });
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </Col>
                <Col xs>
                  <div className="pt-form-group">
                    <label className="pt-label">
                      {required.additional_licenses ? "*" : ""}Licenças
                      adicionais
                    </label>
                    <div className="pt-form-content">
                      <div
                        className={`pt-input-group ${error.additional_licenses ? "pt-intent-danger" : ""}`}
                      >
                        <input
                          type="text"
                          className="pt-input pt-round"
                          placeholder=""
                          value={dataObject.additional_licenses}
                          onChange={({ target }) => {
                            this.onChange({
                              additional_licenses: target.value,
                            });
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col xs={8}>
                  <div className="pt-form-group">
                    <label className="pt-label">
                      {required.internal_url ? "*" : ""}Link para Download
                    </label>
                    <div className="pt-form-content">
                      <div
                        className={`pt-input-group ${error.internal_url ? "pt-intent-danger" : ""}`}
                      >
                        <input
                          type="text"
                          className="pt-input pt-round"
                          placeholder="http://"
                          value={dataObject.download_link}
                          onChange={({ target }) => {
                            this.onChange({ download_link: target.value });
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </Col>
                <Col xs={4}>
                  <div className="pt-form-group">
                    <label className="pt-label">
                      {required.internal_port ? "*" : ""}Versão Sistema
                    </label>
                    <div className="pt-form-content">
                      <div
                        className={`pt-input-group ${error.internal_port ? "pt-intent-danger" : ""}`}
                      >
                        <input
                          type="text"
                          className="pt-input pt-round"
                          placeholder=""
                          value={dataObject.version_app}
                          onChange={({ target }) => {
                            this.onChange({ version_app: target.value });
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col xs={10}>
                  <div className="pt-form-group">
                    <label className="pt-label">
                      {required.internal_url ? "*" : ""}Endereço I
                    </label>
                    <div className="pt-form-content">
                      <div
                        className={`pt-input-group ${error.internal_url ? "pt-intent-danger" : ""}`}
                      >
                        <input
                          type="text"
                          className="pt-input pt-round"
                          placeholder="http://"
                          value={dataObject.internal_url}
                          onChange={({ target }) => {
                            this.onChange({ internal_url: target.value });
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </Col>
                <Col xs={2}>
                  <div className="pt-form-group">
                    <label className="pt-label">
                      {required.internal_port ? "*" : ""}Porta
                    </label>
                    <div className="pt-form-content">
                      <div
                        className={`pt-input-group ${error.internal_port ? "pt-intent-danger" : ""}`}
                      >
                        <input
                          type="text"
                          className="pt-input pt-round"
                          placeholder=""
                          value={dataObject.internal_port}
                          onChange={({ target }) => {
                            this.onChange({ internal_port: target.value });
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col xs={10}>
                  <div className="pt-form-group">
                    <label className="pt-label">
                      {required.external_url ? "*" : ""}Endereço II
                    </label>
                    <div className="pt-form-content">
                      <div
                        className={`pt-input-group ${error.external_url ? "pt-intent-danger" : ""}`}
                      >
                        <input
                          type="text"
                          className="pt-input pt-round"
                          placeholder="http://"
                          value={dataObject.external_url}
                          onChange={({ target }) => {
                            this.onChange({ external_url: target.value });
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </Col>
                <Col xs={2}>
                  <div className="pt-form-group">
                    <label className="pt-label">
                      {required.external_port ? "*" : ""}Porta
                    </label>
                    <div className="pt-form-content">
                      <div
                        className={`pt-input-group ${error.external_port ? "pt-intent-danger" : ""}`}
                      >
                        <input
                          type="text"
                          className="pt-input pt-round"
                          placeholder=""
                          value={dataObject.external_port}
                          onChange={({ target }) => {
                            this.onChange({ external_port: target.value });
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col xs={10}>
                  <div className="pt-form-group">
                    <label className="pt-label">
                      {required.extra_url ? "*" : ""}Endereço III
                    </label>
                    <div className="pt-form-content">
                      <div
                        className={`pt-input-group ${error.extra_url ? "pt-intent-danger" : ""}`}
                      >
                        <input
                          type="text"
                          className="pt-input pt-round"
                          placeholder="http://"
                          value={dataObject.extra_url}
                          onChange={({ target }) => {
                            this.onChange({ extra_url: target.value });
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </Col>
                <Col xs={2}>
                  <div className="pt-form-group">
                    <label className="pt-label">
                      {required.extra_port ? "*" : ""}Porta
                    </label>
                    <div className="pt-form-content">
                      <div
                        className={`pt-input-group ${error.extra_port ? "pt-intent-danger" : ""}`}
                      >
                        <input
                          type="text"
                          className="pt-input pt-round"
                          placeholder=""
                          value={dataObject.extra_port}
                          onChange={({ target }) => {
                            this.onChange({ extra_port: target.value });
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
            </Grid>
            <div
              className="pt-callout pt-intent-danger"
              style={{ display: error.message ? "inherit" : "none" }}
            >
              <h5>{error.response_code}</h5>
              {error.message}
            </div>
          </div>
        </div>
        <div className="pt-dialog-footer">
          <div className="pt-dialog-footer-actions">
            <Button
              intent={Intent.PRIMARY}
              loading={isFetching}
              onClick={() => {
                this.salvar();
              }}
              text="Salvar"
            />
          </div>
        </div>
      </Dialog>
    );
  }

  close() {
    this.props.close();
  }

  onChange(data) {
    this.props.setPropDataObject(data);
  }

  salvar() {
    this.props.salvar().then((data) => {
      this.props.afterSave(data);
    });
  }
}

function mapStateToProps(state) {
  let { dataObject, isOpen, isFetching, error, required } = state.cadAcesso;

  return {
    dataObject,
    isOpen,
    isFetching,
    error,
    required,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ setPropDataObject, salvar, close }, dispatch);
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(CadAcesso),
);



// WEBPACK FOOTER //
// ./src/scenes/acesso/CadAcesso.js